const CREATE_EVENT_GROUP = (state, payload) => {
  state.proposedEvent.eventGroup = payload;
  state.proposedEvent.eventGroupId = payload.id;
};

export default CREATE_EVENT_GROUP;
